import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => {
  return {
    container: {
      display: "flex",
      flexDirection: "column",
      gap: "20px",
    },    secondaryTitle: {
      fontSize: "18px",
      fontWeight: "600",
      lineHeight: "28px",
    },
    gridContainer: {
      display: "flex",
      flex: "1 1 100%",
      flexWrap: "wrap",
      gap: "18px",
      justifyContent: "center",
      [theme.breakpoints.down("sm")]: {
        justifyContent: "center",
      },
    },
        stepperActionContainer: {
      display: "flex",
      justifyContent: "space-between",
      [theme.breakpoints.down("776")]: {
        flexDirection: "column",
        alignItems: "flex-start",
      },
    },
  };
});
